module.exports = __webpack_public_path__ + "static/img/4.f875d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/06/4.png
// module id = YZ5a
// module chunks = 2